var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeartFull(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 7,
    viewBox: "0 0 7 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 0H1V1H3V0Z",
    fill: "#DF3800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 1H0V2H7V1Z",
    fill: "#DF3800"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 2H0V3H7V2Z",
    fill: "#DF3800"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 3H0V4H7V3Z",
    fill: "#DF3800"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6 4H1V5H6V4Z",
    fill: "#DF3800"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5 5H2V6H5V5Z",
    fill: "#DF3800"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6H3V7H4V6Z",
    fill: "#DF3800"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6 0H4V1H6V0Z",
    fill: "#DF3800"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartFull);
export default __webpack_public_path__ + "static/media/heart-full.d3bd73dcc4d70d9d0630e5e7b6bbcda6.svg";
export { ForwardRef as ReactComponent };